// extracted by mini-css-extract-plugin
export default {"title-section":"sYda2NOihn","titleSection":"sYda2NOihn","not-available":"vMxqekBSVY","notAvailable":"vMxqekBSVY"};
    if(module.hot) {
      // 1650538030581
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  